module.exports = __webpack_public_path__ + "static/img/bg2.a134183.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg2.png
// module id = CjTQ
// module chunks = 0